const TRANSACTION_AFFILIATION = 'Reactivate Subscription';
const TRANSACTION_PRODUCTS_NAME = 'FabFitFun VIP Reactivate';
const TRANSACTION_PRODUCSTS_CATEGORY = 'Subscription Box';
const PRODUCT_LABEL = 'VIP Reactivate';
const EVENT_NAME = 'vip_reactivate';

const sendGTMReactivateConversion = (response) => {
  if (!response.ok) {
    return;
  }
  if (!window.dataLayer) {
    window.dataLayer = [];
  }
  const { body } = response;
  window.dataLayer.push({
    transactionId: body.invoice_number,
    transactionAffiliation: TRANSACTION_AFFILIATION,
    transactionTotal: fromCentsToDecimal(body.total_charge_amount),
    transactionTax: fromCentsToDecimal(body.tax_amount),
    transactionShipping: fromCentsToDecimal(body.shipping_fee_amount),
    transactionProducts: [
      {
        sku: body.plan_code,
        name: TRANSACTION_PRODUCTS_NAME,
        category: TRANSACTION_PRODUCSTS_CATEGORY,
        price: fromCentsToDecimal(body.total_charge_amount),
        quantity: 1,
      },
    ],
    productLabel: PRODUCT_LABEL,
    event: EVENT_NAME,
  });
};

const fromCentsToDecimal = (number) => (number ? number / 100.0 : 0.0);

export default sendGTMReactivateConversion;
